import React, { useState, useEffect } from 'react';
import { recordError } from 'utilities/uTagging';

export const useErrors = ({ userProfileFormModelProp }) => {
    const [classError, setClassError] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const changeClassError = change => {
        const classError = change ? 'form__select--error valid-error' : '';
        setClassError(classError);
    };

    const handleInvalidFormError = ({ modelProp, investmentType }) => {
        recordError(`${modelProp}:${errorMessage}`, investmentType ? investmentType : '');
        changeClassError(true);
    };

    useEffect(() => {
        userProfileFormModelProp && changeClassError(!userProfileFormModelProp.valid);
    }, [userProfileFormModelProp]);

    const renderErrors = ({ children }) => {
        setErrorMessage(children);

        return <p className="form__field_error">{children}</p>;
    };

    return {
        classError,
        changeClassError,
        renderErrors,
        handleInvalidFormError,
    };
};
